function _extends() {return _extends = Object.assign ? Object.assign.bind() : function (n) {for (var e = 1; e < arguments.length; e++) {var t = arguments[e];for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);}return n;}, _extends.apply(null, arguments);}var REACT_ELEMENT_TYPE;function _jsx(e, r, E, l) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var o = e && e.defaultProps,n = arguments.length - 3;if (r || 0 === n || (r = { children: void 0 }), 1 === n) r.children = l;else if (n > 1) {for (var t = Array(n), f = 0; f < n; f++) t[f] = arguments[f + 3];r.children = t;}if (r && o) for (var i in o) void 0 === r[i] && (r[i] = o[i]);else r || (r = o || {});return { $$typeof: REACT_ELEMENT_TYPE, type: e, key: void 0 === E ? null : "" + E, ref: null, props: r, _owner: null };} /* eslint-disable react/no-multi-comp */
/* eslint-disable max-statements */
/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import { Translate } from "../../../../../I18N";
import { Button, Card, Sidepanel } from "../../../../Components/UI";
import { Checkbox } from "../../../../Components/Forms";
import { useForm } from 'react-hook-form';
import { useSearchParams } from 'react-router';


















const FiltersSidepanel = ({
  showSidepanel,
  setShowSidepanel,
  aggregation
}) => {
  const [searchParams, setSearchParams] = useSearchParams();

  const defaultFilter = {
    labeled: false,
    nonLabeled: false,
    match: false,
    mismatch: false,
    obsolete: false,
    error: false,
    noContext: false,
    nonProcessed: false
  };

  let initialFilters = defaultFilter;

  try {
    if (searchParams.has('filter')) {
      initialFilters = JSON.parse(searchParams.get('filter'));
    }
  } catch (e) {}

  const { register, handleSubmit, reset, setValue } = useForm({
    values: initialFilters,
    defaultValues: defaultFilter
  });

  const submitFilters = async (filters) => {
    setSearchParams((prev) => {
      prev.set('page', '1');
      prev.set('filter', JSON.stringify(filters));
      return prev;
    });
    setShowSidepanel(false);
  };

  const checkOption = (e, optionName) => {
    const { checked } = e.target;
    setValue(optionName, checked);
  };

  const clearFilters = () => {
    setSearchParams((prev) => {
      prev.delete('filter');
      return prev;
    });
    setShowSidepanel(false);
    reset();
  };

  return (/*#__PURE__*/
    _jsx(Sidepanel, {
      isOpen: showSidepanel,
      withOverlay: true,
      closeSidepanelFunction: () => setShowSidepanel(false),
      title: /*#__PURE__*/
      _jsx("span", { className: "text-base font-semibold uppercase" }, void 0, /*#__PURE__*/
      _jsx(Translate, {}, void 0, "Stats & Filters")
      ) }, void 0, /*#__PURE__*/


    _jsx("form", { onSubmit: handleSubmit(submitFilters), className: "flex flex-col h-full" }, void 0, /*#__PURE__*/
    _jsx(Sidepanel.Body, { className: "flex flex-col flex-grow gap-4" }, void 0, /*#__PURE__*/
    _jsx(Card, {}, void 0, /*#__PURE__*/
    _jsx("div", { className: "text-sm font-semibold text-gray-700 mb-2" }, void 0, /*#__PURE__*/
    _jsx(Translate, {}, void 0, "All data")
    ), /*#__PURE__*/
    _jsx("div", { className: "flex items-center space-x-1" }, void 0, /*#__PURE__*/
    React.createElement(Checkbox, _extends({
      label: /*#__PURE__*/_jsx(Translate, { className: "font-normal" }, void 0, "Labeled") },
    register('labeled'), {
      onChange: (e) => {
        checkOption(e, 'labeled');
      } })
    ), /*#__PURE__*/
    _jsx("div", { className: "flex-1 border-t border-dashed border-t-gray-200" }), /*#__PURE__*/
    _jsx("div", { className: "flex-none font-mono font-bold" }, void 0, aggregation.labeled)
    ), /*#__PURE__*/
    _jsx("div", { className: "flex items-center space-x-1" }, void 0, /*#__PURE__*/
    React.createElement(Checkbox, _extends({
      label: /*#__PURE__*/_jsx(Translate, { className: "font-normal" }, void 0, "Non-labeled") },
    register('nonLabeled'), {
      onChange: (e) => {
        checkOption(e, 'nonLabeled');
      } })
    ), /*#__PURE__*/
    _jsx("div", { className: "flex-1 border-t border-dashed border-t-gray-200" }), /*#__PURE__*/
    _jsx("div", { className: "flex-none font-mono font-bold" }, void 0, aggregation.nonLabeled)
    )
    ), /*#__PURE__*/

    _jsx(Card, {}, void 0, /*#__PURE__*/
    _jsx("div", { className: "text-sm font-semibold text-gray-700 mb-2" }, void 0, /*#__PURE__*/
    _jsx(Translate, {}, void 0, "Status")
    ), /*#__PURE__*/
    _jsx("div", { className: "flex items-center space-x-1" }, void 0, /*#__PURE__*/
    React.createElement(Checkbox, _extends({
      label: /*#__PURE__*/_jsx(Translate, { className: "font-normal" }, void 0, "Non processed") },
    register('nonProcessed'), {
      onChange: (e) => {
        checkOption(e, 'nonProcessed');
      } })
    ), /*#__PURE__*/
    _jsx("div", { className: "flex-1 border-t border-dashed border-t-gray-200" }), /*#__PURE__*/
    _jsx("div", { className: "flex-none font-mono font-bold" }, void 0, aggregation.nonProcessed)
    ), /*#__PURE__*/
    _jsx("div", { className: "flex items-center space-x-1" }, void 0, /*#__PURE__*/
    React.createElement(Checkbox, _extends({
      label: /*#__PURE__*/_jsx(Translate, { className: "font-normal" }, void 0, "Obsolete") },
    register('obsolete'), {
      onChange: (e) => {
        checkOption(e, 'obsolete');
      } })
    ), /*#__PURE__*/
    _jsx("div", { className: "flex-1 border-t border-dashed border-t-gray-200" }), /*#__PURE__*/
    _jsx("div", { className: "flex-none font-mono font-bold" }, void 0, aggregation.obsolete)
    ), /*#__PURE__*/
    _jsx("div", { className: "flex items-center space-x-1" }, void 0, /*#__PURE__*/
    React.createElement(Checkbox, _extends({
      label: /*#__PURE__*/_jsx(Translate, { className: "font-normal" }, void 0, "Error") },
    register('error'), {
      onChange: (e) => {
        checkOption(e, 'error');
      } })
    ), /*#__PURE__*/
    _jsx("div", { className: "flex-1 border-t border-dashed border-t-gray-200" }), /*#__PURE__*/
    _jsx("div", { className: "flex-none font-mono font-bold" }, void 0, aggregation.error)
    )
    ), /*#__PURE__*/

    _jsx(Card, {}, void 0, /*#__PURE__*/
    _jsx("div", { className: "text-sm font-semibold text-gray-700 mb-2" }, void 0, /*#__PURE__*/
    _jsx(Translate, {}, void 0, "Processed")
    ), /*#__PURE__*/
    _jsx("div", { className: "flex items-center space-x-1" }, void 0, /*#__PURE__*/
    React.createElement(Checkbox, _extends({
      label: /*#__PURE__*/_jsx(Translate, { className: "font-normal" }, void 0, "Match") },
    register('match'), {
      onChange: (e) => {
        checkOption(e, 'match');
      } })
    ), /*#__PURE__*/
    _jsx("div", { className: "flex-1 border-t border-dashed border-t-gray-200" }), /*#__PURE__*/
    _jsx("div", { className: "flex-none font-mono font-bold" }, void 0, aggregation.match)
    ), /*#__PURE__*/
    _jsx("div", { className: "flex items-center space-x-1" }, void 0, /*#__PURE__*/
    React.createElement(Checkbox, _extends({
      label: /*#__PURE__*/_jsx(Translate, { className: "font-normal" }, void 0, "Mismatch") },
    register('mismatch'), {
      onChange: (e) => {
        checkOption(e, 'mismatch');
      } })
    ), /*#__PURE__*/
    _jsx("div", { className: "flex-1 border-t border-dashed border-t-gray-200" }), /*#__PURE__*/
    _jsx("div", { className: "flex-none font-mono font-bold" }, void 0, aggregation.mismatch)
    ), /*#__PURE__*/
    _jsx("div", { className: "flex items-center space-x-1" }, void 0, /*#__PURE__*/
    React.createElement(Checkbox, _extends({
      label: /*#__PURE__*/_jsx(Translate, { className: "font-normal" }, void 0, "No context") },
    register('noContext'), {
      onChange: (e) => {
        checkOption(e, 'noContext');
      } })
    ), /*#__PURE__*/
    _jsx("div", { className: "flex-1 border-t border-dashed border-t-gray-200" }), /*#__PURE__*/
    _jsx("div", { className: "flex-none font-mono font-bold" }, void 0, aggregation.noContext)
    )
    )
    ), /*#__PURE__*/
    _jsx(Sidepanel.Footer, { className: "px-4 py-3" }, void 0, /*#__PURE__*/
    _jsx("div", { className: "flex gap-2" }, void 0, /*#__PURE__*/
    _jsx(Button, { className: "flex-grow", type: "button", styling: "outline", onClick: clearFilters }, void 0, /*#__PURE__*/
    _jsx(Translate, {}, void 0, "Clear all")
    ), /*#__PURE__*/
    _jsx(Button, { className: "flex-grow", type: "submit" }, void 0, /*#__PURE__*/
    _jsx(Translate, {}, void 0, "Apply")
    )
    )
    )
    )
    ));

};

export { FiltersSidepanel };